import { render, staticRenderFns } from "./CreateMuseumDetail.vue?vue&type=template&id=5f056bcf&scoped=true"
import script from "./CreateMuseumDetail.vue?vue&type=script&lang=js"
export * from "./CreateMuseumDetail.vue?vue&type=script&lang=js"
import style0 from "./CreateMuseumDetail.vue?vue&type=style&index=0&id=5f056bcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f056bcf",
  null
  
)

export default component.exports